import sharedMutations from '../shared/mutations'
import Cookies from 'js-cookie'

const COOKIE_NAME_VIEW_TYPE = 'preferredForumViewType'
const VIEW_TYPE_ARCHIVE = 'archive'

export default {
  ...sharedMutations,
  setCreatedThread(state, thread) {
    state.threads = [thread].concat(state.threads)
  },
  setMoreThreads(state, threads) {
    state.threads = state.threads.concat(threads)
  },
  setPagination(state, {currentPage, totalPages}) {
    state.pagination.currentPage = currentPage
    state.pagination.totalPages = totalPages
  },
  setThreads(state, threads) {
    state.threads = threads
  },
  setViewType(state, viewType = (Cookies.get(COOKIE_NAME_VIEW_TYPE) || VIEW_TYPE_ARCHIVE)) {
    Cookies.set(COOKIE_NAME_VIEW_TYPE, viewType)
    state.viewType = viewType
  }
}
